module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABFSURBVCiRxdC7DQAgDENBMxkZjc0y2qOAMiCChHBrnfIpSgZokmoaMdKeI5vIPyLAV3vPDsCiMjx6i1b4CAUTrt7up6gDVqyWcJl13QYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/gou.png
// module id = kVc1
// module chunks = 3